import Add from './add/CanAddReferralRequestInitialState'

const { Record } = require('immutable');

export default Record({
    add: Add()
});